import { render, staticRenderFns } from "./AmenityForm.vue?vue&type=template&id=a3251306&scoped=true&"
import script from "./AmenityForm.vue?vue&type=script&lang=js&"
export * from "./AmenityForm.vue?vue&type=script&lang=js&"
import style0 from "./AmenityForm.vue?vue&type=style&index=0&id=a3251306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3251306",
  null
  
)

export default component.exports